module.exports = __webpack_public_path__ + "static/media/Detail_Icon_03.cdf0eac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Detail_Icon_03.png
// module id = 1574
// module chunks = 0